import { RootState } from '@/store'

export const getIsUserLoggedIn = (state: RootState): boolean => Boolean(state.auth.fullName)

export const getUserToken = (state: RootState): string => state.auth.token

export const getCurrentUserRole = (state: RootState) => state.auth.role
